import PatientObjectBaseProvider from "./patientObjectBaseProvider";

export default class PatientPreferencesProvider extends PatientObjectBaseProvider {
	constructor($http, patientProvider, storage, eventBus) {
		super("patientPreferences", $http, patientProvider, storage, eventBus);
	}
}
